<form #myForm="ngForm" class="pz-wrapper">
  <div class="p-fluid">
    <div class="p-field pz-input pz-price-player1">
      <ng-container *ngIf="!pzService.passwordPriceInputMode">
        <p-inputNumber
          locale="de-DE"
          mode="currency"
          currency="EUR"
          id="pricePlayer1"
          name="pricePlayer1"
          inputStyleClass="pz-price-input"
          required
          [(ngModel)]="pzService.model.estimatedPricePlayer1"
          #pricePlayer1="ngModel"
        ></p-inputNumber>
      </ng-container>

      <ng-container *ngIf="pzService.passwordPriceInputMode">
        <p-password
          id="pricePlayer1"
          name="pricePlayer1"
          inputStyleClass="pz-price-input"
          #pricePlayer1="ngModel"
          [feedback]="false"
          [toggleMask]="true"
          [(ngModel)]="pzService.model.estimatedPricePlayer1_password"
          (ngModelChange)="onChangePasswordInput()"
          (keydown)="onKeyDownPasswordInput($event)"
          (togglePriceMask)="togglePriceMask()"
          pzPasswordEye
        ></p-password>
      </ng-container>
    </div>
    <div class="p-field pz-input pz-price-player2">
      <ng-container *ngIf="!pzService.passwordPriceInputMode">
        <p-inputNumber
          locale="de-DE"
          mode="currency"
          currency="EUR"
          id="pricePlayer2"
          name="pricePlayer2"
          inputStyleClass="pz-price-input"
          required
          [(ngModel)]="pzService.model.estimatedPricePlayer2"
          #pricePlayer2="ngModel"
        ></p-inputNumber>
      </ng-container>

      <ng-container *ngIf="pzService.passwordPriceInputMode">
        <p-password
          id="pricePlayer2"
          name="pricePlayer2"
          inputStyleClass="pz-price-input"
          #pricePlayer2="ngModel"
          [feedback]="false"
          [toggleMask]="true"
          [(ngModel)]="pzService.model.estimatedPricePlayer2_password"
          (ngModelChange)="onChangePasswordInput()"
          (keydown)="onKeyDownPasswordInput($event)"
          (togglePriceMask)="togglePriceMask()"
          pzPasswordEye
        ></p-password>
      </ng-container>
    </div>
  </div>

  <div class="svg runde"></div>
  <span class="label-runde" *ngIf="!pzService.isGameFinished()">
    Runde {{ pzService.game }} / {{ pzService.maxRounds }}
  </span>

  <span class="label-runde label-runde-ende" *ngIf="pzService.isGameFinished()">
    Ende
  </span>

  <div class="svg raute raute-player1-price"></div>
  <div class="svg raute raute-player1-points"></div>
  <div
    class="svg senfglas senfglas-player1"
    (click)="setSenfkartePlayer1()"
    [ngClass]="{
      'senfglas-gefuellt': isSenfkartePlayer1(),
      'senfglas-clickable': isSenfkartePlayer1Possible()
    }"
  ></div>
  <div
    class="svg stern stern-player1"
    [ngClass]="{
      'animate-winner-stern': animateWinnerPlayer1,
      'animate-player-stern': animateCurrentPlayer1
    }"
  ></div>
  <span
    class="points-player1"
    [ngClass]="{
      'points-zoom': animatePointsPlayer1
    }"
    >{{ pzService.model.pointsPlayer1 }}</span
  >

  <div class="svg raute raute-player2-price"></div>
  <div class="svg raute raute-player2-points"></div>
  <div
    class="svg senfglas senfglas-player2"
    (click)="setSenfkartePlayer2()"
    [ngClass]="{
      'senfglas-gefuellt': isSenfkartePlayer2(),
      'senfglas-clickable': isSenfkartePlayer2Possible()
    }"
  ></div>
  <div
    class="svg stern stern-player2"
    [ngClass]="{
      'animate-winner-stern': animateWinnerPlayer2,
      'animate-player-stern': animateCurrentPlayer2
    }"
  ></div>
  <span
    class="points-player2"
    [ngClass]="{
      'points-zoom': animatePointsPlayer2
    }"
    >{{ pzService.model.pointsPlayer2 }}</span
  >

  <img
    src="assets/img/kevin.png"
    alt="player1"
    class="img-player img-player1"
    [ngClass]="{
      'animate-player': animatePlayer1,
      'animate-winner': animateWinnerPlayer1
    }"
  />
  <img
    src="assets/img/steven.png"
    alt="player2"
    class="img-player img-player2"
    [ngClass]="{
      'animate-player': animatePlayer2,
      'animate-winner': animateWinnerPlayer2
    }"
  />

  <!-- "Preload" the Senfglas to avoid flickering -->
  <img
    src="assets/svg/senfglas-gefuellt.svg"
    class="preload"
    alt="senfglas-gefuellt"
  />
</form>
<div class="pyro" *ngIf="isWinnerAnimationStarted()">
  <div class="pyro-before"></div>
  <div class="pyro-after"></div>
</div>
